<template>
  <div class="bookgroup">
    <div class="campus">教材系列管理</div>
    <el-card :span="24">
      <div class="header">全部教材系列</div>
      <div class="content">
        <el-button type="primary" class="mb-24" @click="addBookGroup('forms')">新建教材系列</el-button>
        <div class="tableStyle">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="picurl" label="教材系列头像" min-width="50" align="center">
              <template slot-scope="scope"><img height="80px" v-if="scope.row.picurl" :src="scope.row.picurl" alt="">
                <span v-else>暂无头像</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="教材系列名称" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="seqnum" label="教材序列序号" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="publisherName" label="出版社名" min-width="50" align="center">
            </el-table-column>
            <el-table-column prop="publishEnName" label="出版社英文名" min-width="50" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="editBookGroup(scope.row)">编辑</el-button>
                <!-- <el-button type="text" @click="deletBookGroup(scope.row)">删除</el-button>
                <el-button type="text" @click="lookBookGroup(scope.row)">查看</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="dz-flex dz-flex-justify-end mt-12">
          <el-pagination background @size-change="getBookGroupList" @current-change="getBookGroupList" :current-page.sync="page"
            :page-sizes="[5, 10, 30, 50, 100]" :page-size.sync="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 会话框 -->
    <div class="dialogStyle">
      <!-- 新建,编辑教材分类 -->
      <el-dialog :title="dialogType ? '编辑教材分类':'新增教材分类'" :visible.sync="publicDialog" width="600px" center>
        <el-form ref="forms" :model="forms" :rules="FormRules" label-width="120px">
          <el-form-item label="教材系列名称:" prop="name">
            <el-input v-model="forms.name" placeholder="请输入出版社名称"></el-input>
          </el-form-item>
          <el-form-item label="教材系列封面:" prop="img">
            <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.picurl" :show-file-list="false"
              :on-change="collectlist">
              <el-button type="primary" size="samll">上传封面</el-button>
              <div v-show="forms.picurl">
                <img :src="forms.picurl" class="avatar mt-10" />
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label=" 出版社:" prop="publisherid">
            <el-select v-model="forms.publisherid" @change="pressaaa()">
              <el-option v-for="item in pressList" :value="item.id" :label="item.name" :key="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" 排序:" prop="seqnum">
            <el-input-number v-model="forms.seqnum" :min="1" :max="99999999" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label=" 简介:" prop="seqnum">
            <el-input type="textarea" v-model="forms.abstract" label="描述文字"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { $getBookGroupList, $addBookGroup, $editBookGroup } from '@/api/press';
import { $debounce } from '@/utils/index';

const FormRules = {
  name: [
    {
      required: true,
      message: '请输入教材分类',
      trigger: ['blur', 'change'],
    },
  ],
  seqnum: [
    {
      required: true,
      message: '请选择排序',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  name: 'bookgroup',
  props: ['id'],
  data() {
    return {
      pressList: [],
      // publisherid: '',
      FormRules,
      tableData: [],

      page: 1,
      pageSize: 10,
      total: 0,

      publicDialog: false,
      dialogType: '',
      forms: {},
    };
  },
  created() {
    this.$nextTick(() => {
      // 调用 查询出版社列表
      this.getBookGroupList();
      this.getPressList();
    });
  },
  methods: {
    pressaaa() {
      console.log(this.publisherid);
    },
    //上传图片
    collectlist(data) {
      // console.log(data, 'asdad');
      let orgid = window.sessionStorage.getItem('orgid');
      let formData = new FormData();
      formData.append('file', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          // console.log(result);
          if (result.data.code === 0) {
            this.$set(this.forms, 'picurl', result.data.data);
            // console.log(this.forms.picurl, 'asad');
          }
        })
        .catch((err) => {
          // console.log('error===============')
          this.$message.error('上传图片错误：' + err);
        });
    },
    async getBookGroupList() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/bookgroup/bookGroup/publishers/list',
        params: {
          page: this.page,
          pageSize: this.pageSize,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          console.log(result);
          this.tableData = result.data.data;
          this.total = result.data.size;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    //查询出版社列表
    async getPressList() {
      let data = {
        name: this.searchName,
        page: 1,
        pageSize: 999,
      };
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/publisher/selectPublisherPage',
        method: 'POST',
        data: data,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code !== 0) {
            return this.$message.error(result.data.message);
          }
          console.log(result, 'aaaa');
          this.pressList = result.data.data;
        })
        .catch((err) => {
          return this.$message.error('查询失败！：' + err);
        });
    },
    //

    // 新增教材分类
    addBookGroup(formName) {
      this.publicDialog = true;
      this.$nextTick(() => {
        this.forms = {
          publisherid: this.id,
          name: '',
          seqnum: 1,
          orgid: 8,
        };
        this.$refs[formName].resetFields();
        this.dialogType = 0;
      });
    },
    // 编辑出版社
    editBookGroup(row) {
      // console.log(this.publisherid);
      this.forms = {
        name: row.name,
        seqnum: row.seqnum,
        publisherid: row.publisherid,
        id: row.id,
        picurl: row.picurl,
        orgid: Number(window.sessionStorage.getItem('orgid')),
      };
      this.dialogType = 1;
      this.publicDialog = true;
    },
    // 确认新增和编辑出版社  新增dialogType:0 编辑dialogType:1
    submitAdd: $debounce(function () {
      this.$refs['forms'].validate(async (valid) => {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        // 如果表单验证失败，停止请求提交
        // if (!valid) {
        //   this.$message.error('新增信息缺失！');
        //   return;
        // } else
        {
          if (this.dialogType) {
            let pro = this.$http({
              url: '/edu/bookgroup/updateBookGroup',
              method: 'POST',
              data: this.forms,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getBookGroupList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
                this.forms = {};
              })
              .catch((err) => {
                return this.$message.error('编辑失败！：' + err);
              });
          } else {
            // 新增教材分类
            // const res = await $addBookGroup(this.forms);
            // if (res.data.code === 0) {
            //   this.getBookGroupList();
            // }
            // this.$message.success(res.data.message);
            // this.publicDialog = false;

            let pro = this.$http({
              url: '/edu/bookgroup/addBookGroup',
              method: 'POST',
              data: this.forms,
              headers: {
                Authorization: 'Bearer ' + token,
              },
            });
            pro
              .then((result) => {
                if (result.data.code !== 0) {
                  this.publicDialog = false;
                  return this.$message.error(result.data.message);
                }
                this.getBookGroupList();
                this.$message.success(result.data.message);
                this.publicDialog = false;
              })
              .catch((err) => {
                return this.$message.error('新建失败！：' + err);
              });
          }
        }
      });
    }, 500),
  },
};
</script>

<style lang="less">
.bookgroup {
  .el-card__body {
    padding: 0 1.3vw;
  }
}
</style>